import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import "./ChangePassword.css";

const ChangePassword = () => {
  const [form] = Form.useForm();

  const handleSubmit = async () => {
    debugger;
    try {
      const values = await form.validateFields();
      if (values.password2 !== values.password3) {
        message.error("Passwords do not match");
        return;
      }

      const formData = {
        current_password: values.password1,
        new_password: values.password2,
      };
      const response = await fetch("/api/portal/pms/change_password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const responseData = await response.json();

      console.log("API response:", responseData);

      if (responseData.serviceResult !== null) {
        message.success(responseData.serviceResult);
        form.resetFields();
      } else {
        message.error(responseData.serviceError);
      }
    } catch (errorInfo) {
      console.log("Validation failed:", errorInfo);
    }
  };

  return (
    <div className="change-password-container">
      <h2 className="change-password-title">Change Password</h2>
      <Form form={form} layout="vertical" className="change-password-form">
        <Form.Item
          name="password1"
          label="Old Password"
          rules={[
            { required: true, message: "Please input your old password" },
            { min: 6, message: "Password must be at least 6 characters" },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          name="password2"
          label="New Password"
          rules={[
            { required: true, message: "Please input your new password" },
            { min: 6, message: "Password must be at least 6 characters" },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          name="password3"
          label="Confirm New Password"
          rules={[
            { required: true, message: "Please confirm your new password" },
            { min: 6, message: "Password must be at least 6 characters" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password2") === value) {
                  return Promise.resolve();
                }
                return Promise.reject("Passwords do not match");
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <Button type="button" className="submit" onClick={handleSubmit} block>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ChangePassword;
